import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CasesGeneral } from '../../../../../shared/types/modules/cases-general';
import { ACCOUNTS } from '../../../../../routes/paths';
import { asyncGetCasesGeneral } from '../../../../../services/cases-general.service';

export const useCasesGeneralDetail = () => {
    const navigate = useNavigate();
    const { idCasesGeneral } = useParams();
    const [loading, setLoading] = useState(false);
    const [caseGeneral, setCaseGenerals] = useState<CasesGeneral>();

    useEffect(() => {
        if (Boolean(idCasesGeneral?.trim())) {
            setLoading(true);
            asyncGetCasesGeneral(idCasesGeneral?.trim())
                .then((caseGeneral) => {
                    if (caseGeneral) setCaseGenerals(caseGeneral);
                    else navigate(ACCOUNTS);
                })
                .finally(() => setLoading(false));
        }
    }, [idCasesGeneral]);

    return { loading, caseGeneral };
};
